<template>
  <div>
    <router-link :to="{name: 'AdminEshops'}" class="btn btn-outline-secondary btn-sm mb-3">
      <i class="bi bi-arrow-return-left mr-1"></i> Back to list
    </router-link>

    <usage-chart :raw-data="usageData" :loading="usageLoading" />

    <transition mode="out-in">
      <loading-spinner v-if="loading"/>
      <div v-else-if="details">
        <div class="card">
          <div class="card-body d-flex align-items-start">
            <div v-if="details.logoUrl">
              <img :src="details.logoUrl" alt="store logo" style="max-width: 150px;" class="me-3">
            </div>
            <div class="flex-grow-1">
              <h2>{{ details.name }}</h2>
              <h3>{{ details.id }}</h3>
              <div class="small mb-3" v-html="details.description"></div>
            </div>
          </div>
          <div class="card-body">
            <h3>Details</h3>
            <div class=" overflow-auto">
              <table class="table table-sm table-striped">
              <thead>
              <tr>
                <th>Key</th>
                <th>Value</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="td in tableData" :key="td.key" class="small">
                <td><strong>{{ td.key }}</strong></td>
                <td>{{ td.value }}</td>
              </tr>
              </tbody>
            </table>
            </div>
          </div>
          <div class="card-body">
            <h3>Telemetry</h3>
            <div class=" overflow-auto">
              <table class="table table-sm table-striped">
              <thead>
              <tr>
                <th>Date</th>
                <th>Event</th>
                <th>Context</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(td, i) in (details.telemetry || [])" :key="i" class="small">
                <td><strong>{{ td.date }}</strong></td>
                <td>{{ td.event_type }}</td>
                <td>{{ td.context }}</td>
              </tr>
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        {{ error }}
      </div>
    </transition>

    <static-alert :message="error" v-if="error" />
  </div>
</template>

<script setup>
import {ref, defineProps, onMounted, computed} from 'vue'
import { useStore } from 'vuex'
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";
import UsageChart from "@/admin/components/eshops/UsageChart.vue";
const store = useStore()
const props = defineProps(['eshopId'])
const details = ref(null)
const loading = ref(false)
const error = ref(null)
const usageData = ref([])
const usageLoading = ref(false)

const tableData = computed(() => {
  if (!details.value) return []
  const td = []
  td.push({key: 'Onboard Date', value: details.value.create_date})
  td.push({key: 'Timezone', value: details.value.timezone|| ''})
  td.push({key: 'Total Orders', value: details.value.total_orders || 0})
  td.push({key: 'Total Items', value: details.value.total_items || 0})
  const config = details.value.config || []
  config.forEach(c => {
    td.push({key: c.config_key, value:c.config_value})
  })
  return td
})

onMounted(() => {
  getEshopDetails()
  getEshopUsageData()
})

async function getEshopDetails() {
  if (!props.eshopId) return
  loading.value = true
  try {
    const response = await store.state.api.post('/admin/eshops/details', {
      eshop_id: props.eshopId
    })
    details.value = response.data?.details || []
  } catch (e) {
    error.value = e.message
  }
  loading.value = false
}

async function getEshopUsageData() {
  if (!props.eshopId) return
  usageLoading.value = true
  const response = await store.state.api.post('/admin/eshops/eshop-usage-data', {
    eshop_id: props.eshopId
  })
  usageData.value = response.data?.usageData || []
  usageLoading.value = false
}
</script>